import { useEffect, useState } from "react";
import { api, fmtMoney, today, daysAgo } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { Input } from "@/components/ui/input";

export default function PurchasesByVendor() {
    const [from, setFrom] = useState(daysAgo(180));
    const [to, setTo] = useState(today());
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/reports/purchases-by-vendor", { params: { date_from: from, date_to: to } }).then(({ data }) => setData(data)); }, [from, to]);
    return (
        <>
            <PageHeader kicker="REPORTS • PAYABLES" title="Purchases by Vendor" subtitle="Spend split by vendor."
                actions={<><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="w-[140px]" /><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-[140px]" /></>} />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    {data && <table className="fin-table">
                        <thead><tr><th>Vendor</th><th className="num">Bills</th><th className="num">Total</th><th className="num">Paid</th><th className="num">Balance</th></tr></thead>
                        <tbody>{data.rows.map((r) => (<tr key={r.vendor_id}><td className="font-medium">{r.vendor_name}</td><td className="num">{r.bills}</td><td className="num">{fmtMoney(r.total)}</td><td className="num">{fmtMoney(r.paid)}</td><td className="num">{fmtMoney(r.balance)}</td></tr>))}</tbody>
                    </table>}
                </div>
            </PageBody>
        </>
    );
}
